import React from 'react';
import dynamic from 'next/dynamic';
import type { OpenxDialogProps } from '@/app/components/search/components/Modal/OpenXModal/types.ts';
import ErrorBoundary from '@/app/common/components/ErrorBoundary';

export const OpenXModalInner = dynamic(
  () => import('@/app/components/search/components/Modal/OpenXModal/OpenXModalInner.tsx')
);

const OpenXModal = (props: OpenxDialogProps) => (
  <ErrorBoundary id={`OpenXModal-${props.id || 'undefined'}`}>
    <OpenXModalInner {...props}>{props.children}</OpenXModalInner>
  </ErrorBoundary>
);

export default OpenXModal;
